import { render } from "./AddressRecords.vue?vue&type=template&id=db0356b0&scoped=true"
import script from "./AddressRecords.vue?vue&type=script&lang=js"
export * from "./AddressRecords.vue?vue&type=script&lang=js"

import "./AddressRecords.vue?vue&type=style&index=0&id=db0356b0&scoped=true&lang=css"
import "./AddressRecords.vue?vue&type=style&index=1&id=db0356b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0356b0"]])

export default __exports__